import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
  BaseControl,
  SelectControl,
  ToggleControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import ColorPicker from '../../components/ColorPicker';
import Slider from '../../components/Slider';
import { SHAPES } from './shapes';

export default function Inspector({ attributes, setAttributes }) {
  const {
    shape,
    height,
    flipX,
    invert,
    fillType,
    fillColor,
    gradientFrom,
    gradientTo,
    gradientAngle,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={__('Shape', 'brandy-blocks')} initialOpen>
        <SelectControl
          label={__('Shape', 'brandy-blocks')}
          value={shape}
          options={Object.entries(SHAPES).map(([value, { label }]) => ({
            value,
            label,
          }))}
          onChange={(next) => setAttributes({ shape: next })}
          __nextHasNoMarginBottom
        />

        <Slider
          label={__('Height (px)', 'brandy-blocks')}
          value={height}
          onChange={(next) => setAttributes({ height: next })}
          min={8}
          max={320}
        />

        <ToggleControl
          label={__('Flip horizontally', 'brandy-blocks')}
          checked={flipX}
          onChange={(next) => setAttributes({ flipX: next })}
          __nextHasNoMarginBottom
        />

        <ToggleControl
          label={__('Flip vertically', 'brandy-blocks')}
          help={__(
            'Turns a shape that sits on the bottom edge into one that hangs from the top.',
            'brandy-blocks'
          )}
          checked={invert}
          onChange={(next) => setAttributes({ invert: next })}
          __nextHasNoMarginBottom
        />
      </PanelBody>

      <PanelBody title={__('Fill', 'brandy-blocks')} initialOpen>
        <ToggleGroupControl
          label={__('Fill', 'brandy-blocks')}
          value={fillType}
          onChange={(next) => setAttributes({ fillType: next })}
          isBlock
          __nextHasNoMarginBottom
        >
          <ToggleGroupControlOption
            value="solid"
            label={__('Solid', 'brandy-blocks')}
          />
          <ToggleGroupControlOption
            value="gradient"
            label={__('Gradient', 'brandy-blocks')}
          />
        </ToggleGroupControl>

        {fillType === 'gradient' ? (
          <>
            <BaseControl.VisualLabel>
              {__('From', 'brandy-blocks')}
            </BaseControl.VisualLabel>
            <ColorPicker
              color={gradientFrom}
              onChange={(next) => setAttributes({ gradientFrom: next })}
            />

            <BaseControl.VisualLabel>
              {__('To', 'brandy-blocks')}
            </BaseControl.VisualLabel>
            <ColorPicker
              color={gradientTo}
              onChange={(next) => setAttributes({ gradientTo: next })}
            />

            <Slider
              label={__('Angle', 'brandy-blocks')}
              value={gradientAngle}
              onChange={(next) => setAttributes({ gradientAngle: next })}
              min={0}
              max={360}
            />
          </>
        ) : (
          <>
            <BaseControl.VisualLabel>
              {__('Shape color', 'brandy-blocks')}
            </BaseControl.VisualLabel>
            <ColorPicker
              color={fillColor}
              onChange={(next) => setAttributes({ fillColor: next })}
            />
          </>
        )}
      </PanelBody>
    </InspectorControls>
  );
}
